import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  GetSurveyUserReport,
  reset as resetSurveyUser,
} from "../../../features/survey_user/SurveyUserSlice";

import {
  GetAllSurveyUser,
  reset as resetMasterSurvey,
} from "../../../features/SurveySlice";

import { Card, Col, Row } from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";
import Select from "react-select";

import Chart from "react-apexcharts";

const OverviewSurveyUserPage = () => {
  const dispatch = useDispatch();
  const { data: dataMasterSurveyAktif, isLoading: isLoadingMasterSurvey } =
    useSelector((state) => state.survey);
  const {
    data: dataDashboardSurveyUser,
    isLoading: isLoadingDashboardSurveyUser,
  } = useSelector((state) => state.surveyUser);

  // state
  const [masterSurvey, setMasterSurvey] = useState();

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchDataMasterSurvey();
  }, [dispatch, token]);

  const fetchDataMasterSurvey = () => {
    dispatch(resetMasterSurvey());
    dispatch(GetAllSurveyUser({ token }));
  };

  // init the masterSurvey state based on master survey
  useEffect(() => {
    if (dataMasterSurveyDropdown().length > 0) {
      setMasterSurvey({
        ...dataMasterSurveyDropdown()[0].value,
      });
    }
  }, [dataMasterSurveyAktif]);

  const fetchDataDashboardSurveyUser = () => {
    dispatch(resetSurveyUser());
    if (masterSurvey) {
      dispatch(GetSurveyUserReport({ id: masterSurvey?.id, token }));
    }
  };

  const dataMasterSurveyDropdown = () => {
    try {
      const result = (dataMasterSurveyAktif?.data || []).map((item, i) => ({
        value: item,
        label: item.nama,
      }));
      return result;
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    fetchDataDashboardSurveyUser();
  }, [masterSurvey]);

  return (
    <AdminLayout>
      <Header title="Overview" />
      <Card border="light" className="shadow-sm mb-4">
        <Card.Body>
          <Row>
            <Col xs="12">
              <Select
                options={dataMasterSurveyDropdown()}
                placeholder="Pilih master survey"
                value={dataMasterSurveyDropdown()?.find(
                  (e) => e.value.id === masterSurvey?.id
                )}
                isLoading={isLoadingMasterSurvey}
                onChange={(e) => {
                  setMasterSurvey({
                    ...e.value,
                  });
                }}
              />
            </Col>
            <Col xs="12">
              <BarChartDashboardSurvey
                isLoading={isLoadingDashboardSurveyUser}
                data={dataDashboardSurveyUser?.data ? Array.isArray(dataDashboardSurveyUser?.data) ? dataDashboardSurveyUser?.data : [] : []}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </AdminLayout>
  );
};

// component untuk chart point survey
const BarChartDashboardSurvey = (props) => {
  
  const { isLoading, data } = props;

  // option chart line
  const options = {
    series: [
      {
        data: data?.map((e) => e.total),
      },
    ],
    chartOptions: {
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: data?.map((e) => e.deskripsi),
      },
      yaxis: {
        tickAmount: 4, // Specify the number of ticks on the y-axis
        labels: {
          formatter: function (val) {
            let text = "";
            if (val <= 1) {
              text = "TIDAK PUAS";
            } else if (val <= 2) {
              text = "BIASA";
            } else if (val <= 3) {
              text = "PUAS";
            } else if (val >= 4) {
              text = "SANGAT PUAS";
            }
            return text; // Custom y-axis label
          },
        },
      },
      responsive: [
        {
          breakpoint: 600, // Apply different settings for smaller screens
          options: {
            chart: {
              width: "400", // Adjust height for smaller screens
            },
          },
        },
        {
          breakpoint: 490, // Apply different settings for smaller screens
          options: {
            chart: {
              width: "100%", // Adjust height for smaller screens
            },
          },
        },
      ],
    },
  };

  return (
    <Row className="mt-4">
      <Col
        xs="12"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <Chart
            options={options.chartOptions}
            series={options.series}
            type="bar"
            width="450"
          />
        )}
      </Col>
    </Row>
  );
};

// // component untuk chart point survey
// const PieChartDashboardSurvey = (props) => {
//   const { isLoading, detail } = props;

//   // option chart line
//   const options = {
//     series: detail?.map((e) => e.point),
//     chartOptions: {
//       labels: detail?.map((e) => e.deskripsi),
//       responsive: [
//         {
//           breakpoint: 480,
//           options: {
//             chart: {
//               width: 300,
//             },
//             legend: {
//               position: "bottom",
//             },
//           },
//         },
//       ],
//     },
//   };

//   return (
//     <Row>
//       <Col
//         xs="12"
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         {isLoading ? (
//           <p>Loading...</p>
//         ) : (
//           <Chart
//             options={options.chartOptions}
//             series={options.series}
//             type="pie"
//             width="380"
//           />
//         )}
//       </Col>
//     </Row>
//   );
// };

export default OverviewSurveyUserPage;
